import React, { Component } from 'react';
import { Panel, Table, FormControl, FormGroup } from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';

class YourHotel extends Component {
    render() {
        const title = (
            <h3>Your hotel</h3>
        );

        const { baseData } = this.props;

        return (
            <div>
                <Panel header={title}>
                    <Table striped>
                        <tbody>
                            <tr>
                                <th style={{verticalAlign: "middle", width: "40%"}}>Hotel name</th>
                                <td>{baseData.hotelName}</td>
                            </tr>
                            <tr>
                                <th style={{verticalAlign: "middle", width: "40%"}}>Time zone</th>
                                <td>{baseData.timeZone}</td>
                            </tr>
                            <tr>
                                <th style={{verticalAlign: "middle", width: "40%"}}>Date when you started using Clock<br/>for all reservations</th>
                                <td><DatePicker id="datePicker" value={baseData.accountCreationTime} dateFormat="YYYY-MM-DD" onChange={this.props.updateAccountCreationTime}/></td>
                            </tr>
                            <tr>
                                <th style={{verticalAlign: "middle", width: "40%"}}>Using Clock Web Booking Engine?</th>
                                <td>
                                    <FormControl style={{width: "100%", display: "inline"}} componentClass="select" value={this.props.usesClockWbe} onChange={this.props.updateUsingClockWbe}>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </FormControl>
                                </td>
                            </tr>
                            <tr>
                                <th style={{width: "40%"}}>
                                    <div>Select your hotel in the list</div>
                                    <div className="App-notice">(If you don't find your hotel here, please contact support@atomize.com before proceeding)</div>
                                </th>
                                <td>
                                    <div>
                                        <FormGroup controlId="yourOtaInsightHotel">
                                            <FormControl componentClass="select" multiple onChange={this.props.setOtaInsightIdName}>
                                                {this.props.otaInsightChoices.map((comp, index) =>
                                                    <option key={index} value={comp.id + "||" + comp.name}>{comp.name}</option>
                                                )}
                                            </FormControl>
                                        </FormGroup>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <div className="YourHotel-contactInfo ">
                                        Enter the contact information for the primary contact below. This person needs to be available
                                        during the onboarding process to answer any questions that might arise.
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th style={{verticalAlign: "middle", width: "40%"}}>First name</th>
                                <td><FormControl type="text" onChange={this.props.updateFirstName}/></td>
                            </tr>
                            <tr>
                                <th style={{verticalAlign: "middle", width: "40%"}}>Last name</th>
                                <td><FormControl type="text" onChange={this.props.updateLastName}/></td>
                            </tr>
                            <tr>
                                <th style={{width: "40%"}}>
                                    <div>Email address</div>
                                    <div className="App-notice">(This is the address where rate recommendations will be received)</div>
                                </th>
                                <td style={{verticalAlign: "middle"}}><FormControl type="text" onChange={this.props.updateEmail}/></td>
                            </tr>
                            <tr>
                                <th style={{verticalAlign: "middle", width: "40%"}}>Phone number</th>
                                <td><FormControl type="text" onChange={this.props.updatePhoneNumber}/></td>
                            </tr>
                        </tbody>
                    </Table>
                </Panel>
            </div>
        );
    }
}

export default YourHotel;


// WEBPACK FOOTER //
// ./src/components/YourHotel.js